import { CardBackground, Typography } from "@hellocarbo/lasagne";
import {
  CalendarHeart,
  MessageCircle,
  NotepadText,
  Recycle,
} from "lucide-react";
import { useTranslation } from "react-i18next";

import { AdditionalModule } from "@/components/Shared";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";

function AdditionalModules() {
  const { t } = useTranslation(["common", "lca"]);
  const outboundQueryParams = useOutboundQueryParams("acv");

  return (
    <CardBackground className="mt-md">
      <Typography as="h2" step="2" weight="bold">
        {t("lca:additionalModules:title")}
      </Typography>
      <Typography className="mb-md">
        {t("lca:additionalModules:description")}
      </Typography>
      <div className="gap-sm flex flex-col xl:grid xl:grid-cols-4">
        <AdditionalModule
          Icon={Recycle}
          title={t("lca:additionalModules:service1.title")}
          segmentEventName="demo_otherproducts"
          ctaText={t("common:learnMore")}
          ctaHref={`https://try.hellocarbo.com/meetings/julien-janson?${outboundQueryParams}`}
        />
        <AdditionalModule
          Icon={CalendarHeart}
          title={t("lca:additionalModules:service2.title")}
          segmentEventName="demo_otherproducts"
          ctaText={t("common:learnMore")}
          ctaHref={`https://try.hellocarbo.com/meetings/julien-janson?${outboundQueryParams}`}
        />
        <AdditionalModule
          Icon={NotepadText}
          title={t("lca:additionalModules:service3.title")}
          segmentEventName="demo_otherproducts"
          ctaText={t("common:learnMore")}
          ctaHref={`https://try.hellocarbo.com/meetings/julien-janson?${outboundQueryParams}`}
        />
        <AdditionalModule
          Icon={MessageCircle}
          title={t("lca:additionalModules:service4.title")}
          segmentEventName="option_demo_service"
          ctaText={t("common:coachCall")}
          ctaHref={`https://meetings-eu1.hubspot.com/emmanuelle-vignial/demo-acv${outboundQueryParams}`}
        />
      </div>
    </CardBackground>
  );
}

export default AdditionalModules;
